const LOG_PREFIX = '[AdminPanel]';

export const logger = {
  info: (...args: unknown[]) => {
    console.log(LOG_PREFIX, ...args);
  },
  warn: (...args: unknown[]) => {
    console.warn(LOG_PREFIX, ...args);
  },
  error: (...args: unknown[]) => {
    console.error(LOG_PREFIX, ...args);
  },
  debug: (...args: unknown[]) => {
    console.debug(LOG_PREFIX, ...args);
  },
};
